import { render, staticRenderFns } from "./collectPre.vue?vue&type=template&id=03eacc0a"
import script from "./collectPre.vue?vue&type=script&lang=js"
export * from "./collectPre.vue?vue&type=script&lang=js"
import style0 from "./collectPre.vue?vue&type=style&index=0&id=03eacc0a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports